import Image from "next/image";

// text-[#EDD2B9]
//decorativeVectors-> [{ src, positionClass, width }]
export default function HighlightCard({
  heading,
  description,
  iconSrc,
  backgroundColor = "#B3594D",
  textColor,
  decorativeVectors = [],
  button = null,
  backgroundVectorClassName
}) {
  return (
    <div
      className="relative z-5 rounded-[20px] pt-6 px-8 flex flex-col gap-20 md:gap-0 pb-6 lg:pb-[16vh]"
      style={{ backgroundColor }}
    >
      <div className="flex flex-col gap-5">
        {/* Decorative vectors */}
        {decorativeVectors.map((vector, index) => (
          <div key={index} className={`absolute ${vector.positionClass} -z-[1]`}>
            <Image
              src={vector.src}
              alt={`decorative-vector-${index}`}
              className={`${vector.isOpacityVector ? "opacity-20" : ""} ${vector.widthClass || "w-[200px]"}  h-auto  ${backgroundVectorClassName} ${vector?.vectorClassName || ""}`}
              // width={200}
              // height={200}
            />
          </div>
        ))}

        {/* Icon */}
        <div className="mt-4">
          <Image
            src={iconSrc}
            alt="Icon"
            width={60}
            height={60}
            className="w-15 h-auto sm:w-5 md:w-6 lg:w-6 xl:w-[65px] 2xl:w-10"
          />
        </div>

        {/* Heading */}
        <p className={`text-[${textColor}] headings-micro min-h-[75px] lg:min-h-auto`}>{heading}</p>

        {/* Description */}
        <p className={`text-[${textColor}] body-copy-small-text min-h-[210px] lg:min-h-auto`}>
          {description}
        </p>
      </div>
      {button && <div className="flex justify-end md:hidden">{button}</div>}
    </div>
  );
}
